<script setup>
import { useI18n } from 'vue-i18n';
import SingleHookIntegrationPage from '../shared/SingleHookIntegrationPage.vue';

const { t } = useI18n();
</script>

<template>
  <SingleHookIntegrationPage
    integration-id="odoo"
    :header-title="t('INTEGRATION_SETTINGS.ODOO.HEADER')"
    :empty-title="t('INTEGRATION_SETTINGS.ODOO.EMPTY_STATE')"
    :empty-description="t('INTEGRATION_SETTINGS.ODOO.DESCRIPTION')"
    :connect-button-label="t('INTEGRATION_SETTINGS.ODOO.CONNECT_BUTTON')"
    :disconnect-button-label="t('INTEGRATION_SETTINGS.ODOO.DISCONNECT_BUTTON')"
    :connected-title="t('INTEGRATION_SETTINGS.ODOO.CONNECTED')"
    :connected-description="t('INTEGRATION_SETTINGS.ODOO.CONNECTED_DESCRIPTION')"
    :disconnect-confirm="t('INTEGRATION_SETTINGS.ODOO.DISCONNECT.CONFIRM')"
    icon="i-lucide-database"
    icon-class="bg-gradient-to-br from-purple-500 to-indigo-600"
    logo-file="/dashboard/images/integrations/odoo.png"
  />
</template>
